const initState = {
  subtopics: [],
};

const evaluationBReducer = (state = initState, action) => {
  switch (action.type) {
    case "ADDED_EVALUATION_B":
      return {
        ...state,
        addEvaluationBSuccess: {
          message: action.message,
          type: "addEvaluationBSuccess",
          id: action.id,
        },
      };
    case "ADDED_EVALUATION_B_ERROR":
      return {
        ...state,
        addEvaluationBError: {
          message: action.err.message,
          type: "addEvaluationBError",
        },
      };

    case "UPDATED_EVALUATION_B":
      return {
        ...state,
        updateEvaluationBSuccess: {
          message: action.message,
          type: "updateEvaluationBSuccess",
        },
      };
    case "UPDATED_EVALUATION_B_ERROR":
      return {
        ...state,
        updateEvaluationBError: {
          message: action.err.message,
          type: "updateEvaluationBError",
        },
      };

    case "DELETED_EVALUATION_B":
      return {
        ...state,
        deleteEvaluationBSuccess: {
          message: action.message,
          type: "deleteEvaluationBSuccess",
        },
      };

    case "DELETED_EVALUATION_B_ERROR":
      return {
        ...state,
        deleteEvaluationBError: {
          message: action.err.message,
          type: "deleteEvaluationBError",
        },
      };

    default:
      return state;
  }
};

export default evaluationBReducer;
